import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
    root: {
        flexGrow: 1,
        paddingTop: '18px',
    },
    cartButton: {
    },
    title: {
        flexGrow: 1,
        textDecoration: 'none',
        color: '#000',
    },
}));